import $ from 'jquery'

$('.filter-toggle').on('click', function () {
  $('body').toggleClass('filter-active')
})
